import I18nInput from './src/main';

/* istanbul ignore next */
I18nInput.install = function(Vue) {
  Vue.component(I18nInput.name, I18nInput);
};

export default I18nInput;
